import type {clientNotesRouteApi} from "./-route-api";

import {tableURLStateSchema} from "@project/components/data-display/table";
import {z} from "zod";

export const clientNotesSearchSchema = tableURLStateSchema.extend({
  includeDeleted: z.boolean().optional().default(false),
});

export type ClientNotesSearch = z.output<typeof clientNotesSearchSchema>;
export type ClientNotesNavigateFn = ReturnType<typeof clientNotesRouteApi.useNavigate>;
